import { Alert, Autocomplete, Box, Button, Stack, TextField } from "@mui/material";
import { useContext, useState } from "react";
import { SearchesContext } from "../contexts/SearchesContext";

export default function OrderProductType() {
  const {
    order,
    productTypeList,
    productTypeLoadError,
    selectedOrderProductType,
    setSelectedOrderProductType,
    hasUnsavedProductType,
    isSavingProductType,
    saveProductType
  } = useContext(SearchesContext);
  const [message, setMessage] = useState<{ severity: "success" | "error"; text: string } | null>(null);

  const save = async () => {
    setMessage(null);
    try {
      await saveProductType();
      setMessage({ severity: "success", text: "Product Type saved to order." });
    } catch (error) {
      setMessage({
        severity: "error",
        text: error instanceof Error && !('isAxiosError' in error)
          ? error.message
          : "Unable to save Product Type. Please try again."
      });
    }
  };

  return (
    <Box marginTop={4}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "flex-start" }}>
        <Autocomplete
          sx={{ width: { xs: "100%", sm: 450 } }}
          value={selectedOrderProductType}
          options={Array.from(new Set([...productTypeList, ...(order?.productType ? [order.productType] : [])]))}
          disabled={!order || isSavingProductType || !productTypeList.length}
          onChange={(_, value) => {
            setSelectedOrderProductType(value);
            setMessage(null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Product Type"
              placeholder="Start typing..."
              helperText={hasUnsavedProductType ? "Save Product Type to the order before creating a preview." : undefined}
            />
          )}
        />
        <Button
          variant="outlined"
          disabled={!order || !selectedOrderProductType || !hasUnsavedProductType || isSavingProductType || !productTypeList.length}
          onClick={save}
        >
          {isSavingProductType ? "Saving..." : "Save to order"}
        </Button>
      </Stack>
      {productTypeLoadError && <Alert severity="error" sx={{ mt: 2 }}>{productTypeLoadError}</Alert>}
      {message && <Alert severity={message.severity} sx={{ mt: 2 }}>{message.text}</Alert>}
    </Box>
  );
}
